import { HttpRequest, IRequest } from "../../utilities/HttpRequest";
import { Requests } from "./Request";

export const UserService = {
  authorize: (applicationId: string): Promise<any> => {
    const request: IRequest = Object.assign({}, Requests.authorize(applicationId));
    return HttpRequest.getWithHeader(request);
  },
};
